import React, { FC, ReactElement } from 'react'
import { Collection } from '@/utils/types/collections'
import CollectionIcon from '@/components/collection-icon'
import Link from 'next/link'
import { ExternalLink } from 'lucide-react'

const CollectionItem: FC<{ data: Collection }> = (props): ReactElement => {
	const { data } = props

	const onClick = (evt: any) => {
		evt.stopPropagation()
		evt.preventDefault()
		window.open(`/collection/${data.slug}`, '_blank')
	}

	return (
		<Link href={`/creator-dashboard/${data?.slug}`} className="group block min-w-0 overflow-hidden">
			<div className="relative aspect-square overflow-hidden rounded-md border border-border bg-card transition-all duration-200 group-hover:border-accent group-hover:shadow-md group-hover:shadow-accent/5">
				<CollectionIcon
					className="size-full object-cover pointer-events-none absolute inset-0 transition-transform duration-300 group-hover:scale-105"
					collection={data}
				/>
				<div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
				<button
					onClick={onClick}
					className="absolute bottom-1.5 right-1.5 p-1 rounded bg-background/50 backdrop-blur-sm text-foreground/70 hover:text-foreground opacity-0 group-hover:opacity-100 transition-all duration-200"
				>
					<ExternalLink className="size-2.5" />
				</button>
			</div>
			<p className="mt-1 text-xs font-medium truncate text-foreground px-0.5">
				{data?.name}
			</p>
		</Link>
	)
}

export default CollectionItem
